
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-beranda",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-beranda/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-beranda"])
      });
    }
  